export function matchAllWords(text: string, words: RegExp[]): boolean {
    for(let index = 0; index < words.length; index++) {
        if(!text.match(words[index])) {
            return false;
        }
    }
    return true;
}

export function removeSpaces(str) {
    return str.replace(/\s/g, '');
}

export function removeSpecialCharacters(str: string): string {
    return str.replace(/[^a-zA-Z ]/g, "");
}

/**
 * Given a string extracts all the words from it and converts them in case insensitive regular expressions
 * @param {string} text
 * @return {RegExp[]}
 */
export function extractWordsRegularExpressions(text: string): RegExp[] {
    if(!text) {
        return [];
    }

    return text.split(' ')
        .map(word => word.trim())
        .filter(word => word)
        .map(word => new RegExp(word, 'gi'));
}

export function convertStringArrayToString(messages: string[], joinCharacters: string): string {
    return messages.join(joinCharacters);

}